export class Address {
  seq?: number;
  type?: string;
  description?: string;
  identity?: number;
  clientAccountSeq?: number;
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
}
